<template>
  <l-table
    ref="approvedScientificTopicsTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
    search-placeholder="Search by scientific topic or FIO"
    table-title="Approved scientific topics"
  >
    <template #table-busy>
      <div class="text-center text-primary my-2">
        {{ $t('Checking') }} ...
      </div>
    </template>

    <template #cell(fio)="{ data }">
      {{ valueOrDash(data.item.fio) }}
    </template>

    <template #cell(scientific_topic_name)="{ data }">
      <span
        :id="topicPopoverId(data)"
        class="scientific-topic-name"
        tabindex="0"
      >
        {{ valueOrDash(data.item.scientific_topic_name) }}
      </span>
      <b-popover
        v-if="hasTopicTranslations(data.item)"
        :target="topicPopoverId(data)"
        triggers="hover focus"
        placement="auto"
        custom-class="scientific-topic-popover"
      >
        <div class="scientific-topic-translation">
          <strong>RU:</strong>
          <span>{{ valueOrDash(data.item.scientific_topic_name_ru) }}</span>
        </div>
        <div class="scientific-topic-translation mt-50">
          <strong>EN:</strong>
          <span>{{ valueOrDash(data.item.scientific_topic_name_en) }}</span>
        </div>
      </b-popover>
    </template>

    <template #cell(cipher)="{ data }">
      {{ valueOrDash(data.item.cipher) }}
    </template>

    <template #cell(organization_name)="{ data }">
      {{ valueOrDash($langName(data.value)) }}
    </template>

    <template #cell(direction)="{ data }">
      {{ valueOrDash($langName(data.value && data.value.name)) }}
    </template>

    <template #cell(dc_type_name)="{ data }">
      {{ valueOrDash($langName(data.value)) }}
    </template>

    <template #cell(status_name)="{ data }">
      {{ valueOrDash($langName(data.value)) }}
    </template>
  </l-table>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import { BPopover } from 'bootstrap-vue'
import store from '@/store'
import LTable from '@/views/components/LTable.vue'
import approvedScientificTopics from '@/store/approved-scientific-topics'
import ApprovedScientificTopicsFilter from '@/views/components/filters/service/ApprovedScientificTopics'

export default {
  name: 'ApprovedScientificTopics',
  components: {
    BPopover,
    LTable,
  },
  methods: {
    valueOrDash(value) {
      return value || '-'
    },
    hasTopicTranslations(item) {
      return Boolean(item && (item.scientific_topic_name_ru || item.scientific_topic_name_en))
    },
    topicPopoverId(data) {
      const key = data.item.id || data.item.cipher || data.index

      return `approved-scientific-topic-${String(key).replace(/[^A-Za-z0-9_-]/g, '-')}`
    },
  },
  setup() {
    const MODULE_NAME = 'approvedScientificTopics'

    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, approvedScientificTopics)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    const tableColumns = [
      { key: 'index', label: '#', thStyle: { width: '80px' } },
      { key: 'fio', label: 'FIO' },
      { key: 'scientific_topic_name', label: 'Scientific topic' },
      { key: 'cipher', label: 'Cipher' },
      { key: 'organization_name', label: 'Organization' },
      { key: 'direction', label: 'Direction' },
      { key: 'dc_type_name', label: 'Dc Type' },
      { key: 'supervisor_fio', label: 'Supervisor FIO' },
      { key: 'status_name', label: 'Status' },
    ]
    const filterClass = new ApprovedScientificTopicsFilter()

    return {
      MODULE_NAME,
      tableColumns,
      filterClass,
    }
  },
}
</script>

<style lang="scss" scoped>
.scientific-topic-name {
  cursor: help;
}

.scientific-topic-translation {
  display: flex;
  gap: 0.35rem;
  align-items: flex-start;
}

.scientific-topic-translation strong {
  flex: 0 0 auto;
}
</style>
